import React, { useEffect, useState } from 'react'
import PageLoader from '../../shared/PageLoader'
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import { 
  callExcelHeaderToDbColumns, configUpload, employeeAttendanceUpload, 
  employeeLeaveAvailedUpload, employeeLeaveCreditUpload, employeeUpload, 
  employeeWageUpload, getAllCompaniesDetails, getAssociateCompanies, getColumns, 
  downloadFormat,
  getInputModuleMappingDetails, resetConfigUploadDetails, 
  resetEmployeeAttendanceUploadDetails, resetEmployeeLeaveAvailedUploadDetails, 
  resetEmployeeLeaveCreditUploadDetails, resetEmployeeUploadDetails, 
  resetEmployeeWageUploadDetails, resetExcelHeaderToDbColumnsDetails, 
  resetGetColumnsDetails, resetGetConfigMappingDetails,
  resetDownloadFormat
} from '../../../redux/features/inputModule.slice';
import { Box, Button, Drawer, FormControl, FormControlLabel, FormLabel, IconButton, Select as MSelect, InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from '@mui/material';
import { DEFAULT_OPTIONS_PAYLOAD, DEFAULT_PAYLOAD } from '../../common/Table';
import { ERROR_MESSAGES } from '../../../utils/constants';
import { toast } from 'react-toastify';
import { IoMdClose } from 'react-icons/io';
import { Alert } from 'react-bootstrap';
import { download, downloadFileContent, preventDefault } from '../../../utils/common';
import { FaUpload } from 'react-icons/fa';
import Select from "react-select";
import Companies from '../Masters/Companies/Companies';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { hasUserAccess } from '../../../backend/auth';
import { USER_PRIVILEGES } from '../UserManagement/Roles/RoleConfiguration';

const styleUploadModal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '97%',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const customStyles = {
  control: (base:any) => ({
    ...base,
    maxHeight: 150,
    overflow:"auto"
  })
};


const Configurations = () => {

  const dispatch = useAppDispatch();

  const companiesDetails = useAppSelector((state) => state.inputModule.companiesDetails);
  const associateCompaniesDetails = useAppSelector((state) => state.inputModule.associateCompaniesDetails);

  const companies = companiesDetails && companiesDetails.data.items || []
  const associateCompanies = associateCompaniesDetails && associateCompaniesDetails.data.items || []

  const configUploadDetails = useAppSelector((state) => state.inputModule.configUploadDetails);
  const getColumnsDetails = useAppSelector((state) => state.inputModule.getColumnsDetails);
  const getDownloadFormat = useAppSelector((state) => state.inputModule.downloadFormat);
  const excelHeaderToDbColumnsDetails = useAppSelector((state) => state.inputModule.excelHeaderToDbColumnsDetails);
  const employeeUploadDetails = useAppSelector((state) => state.inputModule.employeeUploadDetails);
  const employeeAttendanceUploadDetails = useAppSelector((state) => state.inputModule.employeeAttendanceUploadDetails);
  const employeeLeaveCreditUploadDetails = useAppSelector((state) => state.inputModule.employeeLeaveCreditUploadDetails);
  const employeeLeaveAvailedUploadDetails = useAppSelector((state) => state.inputModule.employeeLeaveAvailedUploadDetails);
  const employeeWageUploadDetails = useAppSelector((state) => state.inputModule.employeeWageUploadDetails);
  const configMappingDetails = useAppSelector((state) => state.inputModule.configMappingDetails)

  const configMappingList = configMappingDetails && configMappingDetails.data.items || []

  const configurationList = configUploadDetails && configUploadDetails.data.items || []
  const columnsList = getColumnsDetails && getColumnsDetails.data.columns

  const loading = configMappingDetails.status === 'loading' || employeeUploadDetails.status === 'loading' || employeeAttendanceUploadDetails.status === 'loading' || employeeLeaveCreditUploadDetails.status === 'loading' || employeeLeaveAvailedUploadDetails.status === 'loading' || employeeWageUploadDetails.status === 'loading' || configUploadDetails.status === 'loading' || getColumnsDetails.status === 'loading' || excelHeaderToDbColumnsDetails.status === 'loading' || companiesDetails.status === 'loading' || associateCompaniesDetails.status === 'loading'

  const [company, setCompany] = React.useState('');
  const [associate_company, setAssociateCompany] = React.useState('');
  const [configType, setConfigType] = React.useState<any>('');

  const [openUploadModal, setOpenUploadModal] = React.useState(false);
  const [uploadData, setUploadData] =  React.useState<any>();
  const [uploadError, setUploadError] = React.useState(false);

  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);

  const [tableData, setTableData] = React.useState<any>([]);

  const [errorfilepath,setErrorFilePath]=React.useState<any>();

  const [showmappinglne,setShowMappingLine]= React.useState(false);

  const [showUploadMessage, setShowUploadMessage] = React.useState(false);

  const [enableUpdate, setEnableUpdate] = React.useState(false);

  const handleChangeConfigType = (event:any) => {
    setCompany('')
    setAssociateCompany('')
    resetDataValues()
    setConfigType(event.target.value)
  }

  const handleChangeCompany = (event:any) => {
    setAssociateCompany('')
    resetDataValues()
    setCompany(event.target.value);
  };

  const handleChangeAssociateCompany = (event:any) => {
    resetDataValues()
    setAssociateCompany(event.target.value);
  };

  const handleChangeEzycompField = (event:any, fieldData: any) => {
    console.log('eve',event)
    const newTableData = tableData.map((each:any) => {
      if(each.id === fieldData.id){
        return {...each, employee_field_name: event.value, mapped: true}
      }else{
        return each
      }
    })
    console.log('new tb', newTableData)
    setTableData(newTableData)
  }

  useEffect(() => {
    setUploadError(false);

    resetStateValues()
    const companiesPayload: any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true } }
    dispatch(getAllCompaniesDetails(companiesPayload))
  },[])

  useEffect(() => {
    const payload:any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: false, parent_company_id_eq: company } }
    if(company){
      dispatch(getAssociateCompanies(payload))
    }
  }, [company])

  useEffect(() => {
    if(associate_company){
      const payload = {
        search: '', 
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company
        },
        per: 200,
        page: 1,
        sorts: ['company_id asc'],
        "includeCentral": true
      }
      dispatch(getInputModuleMappingDetails(payload))
    } else {
      resetDataValues()
    }
  }, [associate_company]);

  // useEffect(() => {
  //   if(employeeUploadDetails.status === 'succeeded'){
  //     if(employeeUploadDetails.data.key === 'FAILURE'){
  //       const formData = new FormData();
  //       const data = uploadData ? uploadData[0] : []
  //       formData.append('file', data);
  //       formData.append('Remarks', 'NA')
  //       formData.append('Mapped', 'false')
  //       formData.append('ConfigurationType', configType)
  //       formData.append('CompanyId', company)
  //       formData.append('AssociateCompanyId', associate_company)
  //       dispatch(configUpload(formData))
  //     }else{
  //       resetStateValues()
  //       toast.success(`Upload Successfull`)
  //     }
  //   }else if (employeeUploadDetails.status === 'failed'){
  //     toast.error(ERROR_MESSAGES.DEFAULT);
  //   }
  // }, [employeeUploadDetails.status])


  useEffect(() => {
    if(employeeUploadDetails.status === 'succeeded'){
      const contentType = employeeUploadDetails.data && employeeUploadDetails.data.headers['content-type'] || "";
      if (contentType.includes('application/json')) {
        const payload = {
          search: '', 
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company
          },
          per: 200,
          page: 1,
          sorts: ['company_id asc'],
          "includeCentral": true
        }
        dispatch(getInputModuleMappingDetails(payload))
        resetUploadDetails()
        setOpenUploadModal(false)
        toast.success(employeeUploadDetails.data.statusMessage || 'Upload Successfull');
      } else {
        setErrorFilePath(employeeUploadDetails.data);
        setUploadError(true);
      }
    } else if (employeeUploadDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeUploadDetails());
      dispatch(resetConfigUploadDetails());
    }
    
  }, [employeeUploadDetails.status])

  useEffect(() => {
    if(employeeAttendanceUploadDetails.status === 'succeeded'){
      const contentType = employeeAttendanceUploadDetails.data && employeeAttendanceUploadDetails.data.headers['content-type'] || "";
      if (contentType.includes('application/json')) {
        const payload = {
          search: '', 
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company
          },
          per: 200,
          page: 1,
          sorts: ['company_id asc'],
          "includeCentral": true
        }
        dispatch(getInputModuleMappingDetails(payload))
        resetUploadDetails()
        setOpenUploadModal(false)
        toast.success(employeeAttendanceUploadDetails.data.statusMessage || 'Upload Successfull');
      } else {
        setErrorFilePath(employeeAttendanceUploadDetails.data);
        setUploadError(true);
      }
    } else if (employeeAttendanceUploadDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeAttendanceUploadDetails());

      dispatch(resetConfigUploadDetails());
    }
  }, [employeeAttendanceUploadDetails.status])



  


  // useEffect(() => {
  //   if(employeeAttendanceUploadDetails.status === 'succeeded'){
  //     if(employeeAttendanceUploadDetails.data.key === 'FAILURE'){
  //       const formData = new FormData();
  //       const data = uploadData ? uploadData[0] : []
  //       formData.append('file', data);
  //       formData.append('Remarks', 'NA')
  //       formData.append('Mapped', 'false')
  //       formData.append('ConfigurationType', configType)
  //       formData.append('CompanyId', company)
  //       formData.append('AssociateCompanyId', associate_company)
  //       dispatch(configUpload(formData))
  //     }else{
  //       resetStateValues()
  //       toast.success(`Upload Successfull`)
  //     }
  //   }else if (employeeAttendanceUploadDetails.status === 'failed'){
  //     toast.error(ERROR_MESSAGES.DEFAULT);
  //   }
  // }, [employeeAttendanceUploadDetails.status])

  // useEffect(() => {
  //   if(employeeLeaveCreditUploadDetails.status === 'succeeded'){
  //     if(employeeLeaveCreditUploadDetails.data.status === 'NOTSETUP'){
  //       const formData = new FormData();
  //       const data = uploadData ? uploadData[0] : []
  //       formData.append('file', data);
  //       formData.append('Remarks', 'NA')
  //       formData.append('Mapped', 'false')
  //       formData.append('ConfigurationType', configType)
  //       formData.append('CompanyId', company)
  //       formData.append('AssociateCompanyId', associate_company)
  //       dispatch(configUpload(formData))
  //     }else{
  //       resetStateValues()
  //       toast.success(`Upload Successfull`)
  //     }
  //   }else if (employeeLeaveCreditUploadDetails.status === 'failed'){
  //     toast.error(ERROR_MESSAGES.DEFAULT);
  //   }
  // }, [employeeLeaveCreditUploadDetails.status])

  useEffect(() => {
    if(employeeLeaveCreditUploadDetails.status === 'succeeded'){
      const contentType = employeeLeaveCreditUploadDetails.data && employeeLeaveCreditUploadDetails.data.headers['content-type'] || "";
      if (contentType.includes('application/json')) {
        const payload = {
          search: '', 
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company
          },
          per: 200,
          page: 1,
          sorts: ['company_id asc'],
          "includeCentral": true
        }
        dispatch(getInputModuleMappingDetails(payload))
        resetUploadDetails()
        setOpenUploadModal(false)
        toast.success(employeeLeaveCreditUploadDetails.data.statusMessage || 'Upload Successfull');
      } else {
        setErrorFilePath(employeeLeaveCreditUploadDetails.data);
        setUploadError(true);
      }
    } else if (employeeLeaveCreditUploadDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeLeaveCreditUploadDetails());

      dispatch(resetConfigUploadDetails());
    }
  }, [employeeLeaveCreditUploadDetails.status])

  useEffect(() => {
    if(employeeLeaveAvailedUploadDetails.status === 'succeeded'){
      const contentType = employeeLeaveAvailedUploadDetails.data && employeeLeaveAvailedUploadDetails.data.headers['content-type'] || "";
      if (contentType.includes('application/json')) {
        const payload = {
          search: '', 
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company
          },
          per: 200,
          page: 1,
          sorts: ['company_id asc'],
          "includeCentral": true
        }
        dispatch(getInputModuleMappingDetails(payload))
        resetUploadDetails()
        setOpenUploadModal(false)
        toast.success(employeeLeaveAvailedUploadDetails.data.statusMessage || 'Upload Successfull');
      } else {
        setErrorFilePath(employeeLeaveAvailedUploadDetails.data);
        setUploadError(true);
      }
    } else if (employeeLeaveAvailedUploadDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeLeaveCreditUploadDetails());

      dispatch(resetConfigUploadDetails());
    }
  }, [employeeLeaveAvailedUploadDetails.status])



  // useEffect(() => {
  //   if(employeeLeaveAvailedUploadDetails.status === 'succeeded'){
  //     if(employeeLeaveAvailedUploadDetails.data.key === 'FAILURE'){
  //       const formData = new FormData();
  //       const data = uploadData ? uploadData[0] : []
  //       formData.append('file', data);
  //       formData.append('Remarks', 'NA')
  //       formData.append('Mapped', 'false')
  //       formData.append('ConfigurationType', configType)
  //       formData.append('CompanyId', company)
  //       formData.append('AssociateCompanyId', associate_company)
  //       dispatch(configUpload(formData))
  //     }else{
  //       resetStateValues()
  //       toast.success(`Upload Successfull`)
  //     }
  //   }else if (employeeLeaveAvailedUploadDetails.status === 'failed'){
  //     toast.error(ERROR_MESSAGES.DEFAULT);
  //   }
  // }, [employeeLeaveAvailedUploadDetails.status])

  useEffect(() => {
    if(employeeWageUploadDetails.status === 'succeeded'){
      const contentType = employeeWageUploadDetails.data && employeeWageUploadDetails.data.headers['content-type'] || "";
      if (contentType.includes('application/json')) {
        const payload = {
          search: '', 
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company
          },
          per: 200,
          page: 1,
          sorts: ['company_id asc'],
          "includeCentral": true
        }
        dispatch(getInputModuleMappingDetails(payload))
        resetUploadDetails()
        setOpenUploadModal(false)
        toast.success(employeeWageUploadDetails.data.statusMessage || 'Upload Successfull')
      } else {
        setErrorFilePath(employeeWageUploadDetails.data);
        setUploadError(true);
      }
    } else if (employeeWageUploadDetails.status === 'failed') {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeUploadDetails());
      dispatch(resetConfigUploadDetails());
    }
  }, [employeeWageUploadDetails.status])
  
  useEffect(() => {
    if(configUploadDetails.status === 'succeeded'){
      const contentType = configUploadDetails.data && configUploadDetails.data.headers['content-type'] || "";
      if (contentType.includes('application/json')) {
        const payload = {
          search: '', 
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company
          },
          per: 200,
          page: 1,
          sorts: ['company_id asc'],
          "includeCentral": true
        }
        dispatch(getInputModuleMappingDetails(payload))
        resetUploadDetails()
        setOpenUploadModal(false)
      } else {
        setErrorFilePath(configUploadDetails.data);
        setUploadError(true);
      }
    } else if(configUploadDetails.data.file_path!= null ) {
      setUploadError(true);
    } else if (configUploadDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeUploadDetails());
      dispatch(resetConfigUploadDetails());
    }
  }, [configUploadDetails.status])

  useEffect(() => {
    if(excelHeaderToDbColumnsDetails.status === 'succeeded'){
      toast.success("Mappings Updated Successfully");
      toast.info("Upload the Data Now");
      const payload = {
        search: '', 
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company
        },
        per: 200,
        page: 1,
        sorts: ['company_id asc'],
        "includeCentral": true
      }
      dispatch(getInputModuleMappingDetails(payload))
      // setTableData([]);
      // alert("466excelheaderto db col hitted ")
      // const formData = new FormData();
      // const data = uploadData ? uploadData[0] : []
      // formData.append('file', data);
      // formData.append('Remarks', 'NA')
      // formData.append('Mapped', 'true')
      // formData.append('ConfigurationType', configType)
      // formData.append('CompanyId', company)
      // formData.append('AssociateCompanyId', associate_company)
      // if(configType === 'Employee'){
      //   dispatch(employeeUpload(formData))
      // }else if(configType === 'Employee attendance'){
      //   dispatch(employeeAttendanceUpload(formData))
      // }else if(configType === 'Leave credit'){
      //   dispatch(employeeLeaveCreditUpload(formData))
      // }else if(configType === 'Leave availed'){
      //   dispatch(employeeLeaveAvailedUpload(formData))
      // }else if(configType === 'Employee Wage'){
      //   dispatch(employeeWageUpload(formData))
      // }
    }else if(excelHeaderToDbColumnsDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  },[excelHeaderToDbColumnsDetails.status])

  
  const getBackendConfigType = (type: string) => {
    let backend_type = '';
    switch(type) {
      case 'Employee':
        backend_type = 'employee'
        break;
      case 'Employee Attendance':
        backend_type = 'employee_attendance'
        break;
      case 'Leave Credit':
        backend_type = 'employee_leave_credit'
        break;
      case 'Leave Availed':
        backend_type = 'employee_leave_availed'
        break;
      case 'Employee Wage':
        backend_type = 'employee_wage'
        break;
    }
    return backend_type;
  }
  
  useEffect(() => {
    if(configMappingDetails.status === 'succeeded'){
      if(configMappingList && configMappingList.length > 0){
        const mappedArray: any[] = configMappingList.map((each: any) => each.mapped)
        if(mappedArray.every(val => val)){
          setEnableUpdate(false);
        } else {
          setShowMappingLine(true);
          setEnableUpdate(true);
        }
        setTableData(configMappingList)
        const backend_type = getBackendConfigType(configType);
        dispatch(getColumns(backend_type))
      } else {
        setTableData([])
        setShowUploadMessage(true);
      }
    } else if(configMappingDetails.status === 'failed'){
      toast.error(ERROR_MESSAGES.DEFAULT);
      resetGetConfigMappingDetails()
    }
  }, [configMappingDetails.status])

  const configurationTypes = ["Employee", "Leave Credit", 'Leave Availed', 'Employee Attendance', 'Employee Wage' ]
//   const configurationTypes = [
//   { display: "Employee Master", value: "Employee" },
//   { display: "Leave Credit", value: "Leave Credit" },
//   { display: "Leave Availed", value: "Leave Availed" },
//   { display: "Employee Attendance", value: "Employee Attendance" },
//   { display: "Employee Wage", value: "Employee Wage" }
// ];

  const onClickUpload = () => {
    if(!company || !associate_company || !configType){
      return toast.error(ERROR_MESSAGES.FILL_ALL);
    } else{
      setOpenUploadModal(true)
    }
  }

  const onClickSubmitUpload = () => {
    const formData = new FormData();
    const data = uploadData ? uploadData[0] : []
    formData.append('file', data);
    formData.append('remarks', 'NA')
    formData.append('mapped', 'false')
    formData.append('configuration_type', configType)
    formData.append('company_id', company)
    formData.append('associate_company_id', associate_company)
    console.log(formData.values);
    if(configMappingList && configMappingList.length > 0){
      if(configType === 'Employee'){
        dispatch(employeeUpload(formData))
      } else if(configType === 'Employee Attendance'){
        dispatch(employeeAttendanceUpload(formData))
      } else if(configType === 'Leave Credit'){
        dispatch(employeeLeaveCreditUpload(formData))
      } else if(configType === 'Leave Availed'){
        dispatch(employeeLeaveAvailedUpload(formData))
      } else if(configType === 'Employee Wage'){
        dispatch(employeeWageUpload(formData))
      }
    } else {
      dispatch(configUpload(formData))
    }
  }
//  const configurationTypes = ["Employee", "Leave Credit", 'Leave Availed', 'Employee Attendance', 'Employee Wage' ]

  const onClickSave = () => {
    console.log('ttabbel', tableData)
    const check = tableData.find((each:any) => (each.employeeFieldName === null || each.employeeFieldName === ''))
    if(check){
      return toast.error('Please Select All Ezycomp Fields');
    } else{
     
      dispatch(callExcelHeaderToDbColumns({list_excel_header_to_db_columns_map : tableData}))
      setShowMappingLine(false);
    }
  }

  const onClickPreview = () => {  
    if(!company || !associate_company || !configType){
      return toast.error(ERROR_MESSAGES.FILL_ALL);
    }else{
      const payload = {
        search: '', 
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company
        },
        per: 200,
        page: 1,
        sorts: ['company_id asc'],
        "includeCentral": true
      }
      // dispatch(getInputModuleMappingDetails(payload))
      setOpenPreviewModal(true)
    }
  }

  const downloadErrors = (e: any) => {
    preventDefault(e);
    const data = errorfilepath.data;
    const blob = new Blob([data], { type: errorfilepath.headers['content-type'] })
    const URL = window.URL || window.webkitURL;
    const downloadUrl = URL.createObjectURL(blob);
    download('Errors.xlsx', downloadUrl);
}

  const downloadErrorsold = (e: any) => {
    preventDefault(e);
    const data: any = {};
    employeeUploadDetails.data.status
    const blob = new Blob([data])
    const URL = window.URL || window.webkitURL;
    const downloadUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = 'Errors.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  //console.log('leve dett', employeeLeaveCreditUploadDetails)

  const resetUploadDetails = () => {
    dispatch(resetConfigUploadDetails())
    dispatch(resetEmployeeUploadDetails())
    dispatch(resetEmployeeAttendanceUploadDetails())
    dispatch(resetEmployeeLeaveCreditUploadDetails())
    dispatch(resetEmployeeLeaveAvailedUploadDetails())
    dispatch(resetEmployeeWageUploadDetails())
    setUploadError(false)
  }

  const handleDownloadFormat = () => {
    //const backend_type = getBackendConfigType(configType);
    dispatch(
      downloadFormat({
        type: configType, associate_company_id: associate_company
      })
    )
  }

  const closeMappingPreview =()=>{
    //alert("hitted close mapping preview");
    dispatch(resetConfigUploadDetails())
    // dispatch(resetGetColumnsDetails())
    dispatch(resetExcelHeaderToDbColumnsDetails())
    dispatch(resetEmployeeUploadDetails())  
    dispatch(resetEmployeeAttendanceUploadDetails())
    dispatch(resetEmployeeLeaveCreditUploadDetails())
    dispatch(resetEmployeeLeaveAvailedUploadDetails())
    dispatch(resetEmployeeWageUploadDetails())
    // dispatch(resetGetConfigMappingDetails())
    setOpenPreviewModal(false);
    setOpenPreviewModal(false);
    setUploadData(null)
    //setTableData([])
    setShowMappingLine(false);
  }

  const resetStateValues = () => {
    dispatch(resetConfigUploadDetails())
    dispatch(resetGetColumnsDetails())
    dispatch(resetExcelHeaderToDbColumnsDetails())
    dispatch(resetEmployeeUploadDetails())
    dispatch(resetEmployeeAttendanceUploadDetails())
    dispatch(resetEmployeeLeaveCreditUploadDetails())
    dispatch(resetEmployeeLeaveAvailedUploadDetails())
    dispatch(resetEmployeeWageUploadDetails())
    dispatch(resetGetConfigMappingDetails())

    setOpenUploadModal(false)
    setOpenPreviewModal(false)
    setConfigType('')
    setCompany('')
    setAssociateCompany('')
    setUploadData(null)
    setTableData([])
    setShowUploadMessage(false);
  }

  const resetDataValues = () =>{
    dispatch(resetConfigUploadDetails())
    dispatch(resetGetColumnsDetails())
    dispatch(resetExcelHeaderToDbColumnsDetails())
    dispatch(resetEmployeeUploadDetails())
    setUploadData(null)
    setTableData([])
  } 

  return (
    <div style={{ backgroundColor:'#ffffff', height:'100vh'}}>

      {/* Upload Modal */}
      <Modal
        open={openUploadModal}
        onClose={() => {setOpenUploadModal(false); setUploadError(false); setUploadData(null)}}
      >
        <Box sx={styleUploadModal}>
          <Box sx={{backgroundColor:'#E2E3F8', padding:'10px', px:'20px', borderRadius:'6px', boxShadow: '0px 6px 10px #CDD2D9', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <Typography sx={{font: 'normal normal normal 32px/40px Calibri'}}>Configuration Upload</Typography>
            <IconButton
              onClick={() => {setOpenUploadModal(false); setUploadError(false); setUploadData(null)}}
            >
              <IoMdClose />
            </IconButton>
          </Box>

          {uploadError &&
            <Alert variant="danger" className="mx-4 my-4">
              There are few errors identified in the file uploaded. Correct the errors and upload again. <a href="/" onClick={downloadErrors}>Click here</a> to download the errors.
            </Alert>
          }

          <Box sx={{padding:'20px', backgroundColor:'#ffffff', display:'flex', justifyContent:'center'}}>
            <Box sx={{display:'flex', flexDirection:'column'}}>
                <Typography mb={1} color={'#0F67B1'} fontWeight={'bold'} sx={{font: 'normal normal normal 24px/28px Calibri'}}>Upload File <span style={{color:'red'}}>*</span></Typography>
                <input
                  style={{ border:'1px solid #0F67B1', width:'500px', height:'40px', borderRadius:'5px'}}
                  type="file"
                  accept='.xlsx, .xls, .csv'
                  onClick={(e: any) => e.target.value = ''}
                  onChange={(e) => setUploadData(e.target.files)}
                />
            </Box>
          </Box>

          <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:5}}>
            <Button variant='contained' disabled={!uploadData} onClick={onClickSubmitUpload}>Submit</Button>
          </Box>

          <Box sx={{display:'flex', padding:'20px', borderTop:'1px solid #6F6F6F',justifyContent:'flex-end', alignItems:'center', mt:4}}>
                <Button variant='contained' sx={{backgroundColor:'#707070'}} onClick={() => {setOpenUploadModal(false); setUploadError(false); setUploadData(null)}}>Cancel</Button>
          </Box>
        </Box>
      </Modal>

      {/* Preview Modal */}
      <Modal
        open={openPreviewModal}
        onClose={() => {closeMappingPreview()}}
      >

        <Box sx={style}> 
          <Box sx={{ backgroundColor: '#E2E3F8', padding: '10px', px: '20px', borderRadius: '6px', boxShadow: '0px 6px 10px #CDD2D9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{display: "flex", flexDirection: "column"}}>
            <Typography sx={{ font: 'normal normal normal 32px/40px Calibri' }}> {configType} Mapping Details </Typography>
            {companies && companies.map((each: any) => {
              if (each.id == company) {
                return <Typography>Company Name &nbsp; &nbsp; &nbsp; &nbsp;: &nbsp; &nbsp; &nbsp; <span style={{ font: 'normal normal normal 24px/30px Calibri' }}>{each.name}</span> </Typography>
               }
            })} 
              <Box sx={{ display: "flex", alignItems: 'center'}} >
              {associateCompanies && associateCompanies.map((each: any) => {
                if (each.id == associate_company) {
                  return <Typography>AssociateCompany &nbsp;: &nbsp; &nbsp; &nbsp; <span style={{ font: 'normal normal normal 24px/30px Calibri', marginRight: '20px' }}>{each.name}</span></Typography>
                }
              })}
            </Box>
            </Box>
              <IconButton
                onClick={() => {closeMappingPreview()}}
              >
                <IoMdClose />
              </IconButton>
            </Box>
            <Box sx={{paddingX: '20px', display: 'flex', flexDirection:'column'}}>
              {
                tableData && tableData.length == 0 ? 
                <Box sx={{height:'60vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                  <Typography variant='h5'>No Records Found</Typography>
                </Box>
                : 
                <>
                  <TableContainer sx={{border:'1px solid #e6e6e6', marginTop:'10px', maxHeight:'380px', overflowY:'scroll'}}>
                          <Table stickyHeader  sx={{ minWidth: 650 }} aria-label="sticky table">
                              <TableHead sx={{'.MuiTableCell-root':{ backgroundColor:'#E7EEF7',fontWeight:'600'}}}>
                                  <TableRow>
                                      <TableCell > S.no</TableCell>
                                      <TableCell > Column Name</TableCell>
                                      <TableCell > Column Position</TableCell>
                                      <TableCell > Row Position</TableCell>
                                      <TableCell > Ezycomp Field</TableCell>
                                      <TableCell > Mapped</TableCell>
                                  </TableRow>
                              </TableHead>

                              <TableBody>

                              {tableData && tableData.map((each: any, index: number) => (
                                  <TableRow
                                    key={each._id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >   
                                      <TableCell >{index+1}</TableCell>
                                      <TableCell >{each.excel_column_header_name}</TableCell>
                                      <TableCell >{each.column_position}</TableCell>
                                      <TableCell >{each.row_position}</TableCell>
                                      <TableCell >{each.employee_field_name}</TableCell>
                                      <TableCell >{each.mapped ? "Yes" : "No"}</TableCell>
                                    </TableRow>
                              ))}
                              </TableBody>
                          </Table>
                  </TableContainer>
                </>
              }
            </Box>

            <Box sx={{display:'flex', padding:'20px', borderTop:'1px solid #6F6F6F',justifyContent:'space-between', alignItems:'center', mt:4}}>
              <Button variant='contained' sx={{backgroundColor:'#707070'}} onClick={() => {closeMappingPreview()}}>Cancel</Button>
              <Button variant='contained' sx={{backgroundColor:'#707070'}} onClick={() => {handleDownloadFormat()}}>Download Format</Button>
            </Box>

        </Box>

      </Modal>

      {loading ? <PageLoader>Loading...</PageLoader> : 
        <div >

            {/* Filter Box*/}
            <Box sx={{paddingX: '20px', paddingY:'10px',}}>
              <Box sx={{backgroundColor:'#E2E3F8', paddingX: '20px', paddingY:'10px', borderRadius:'6px', boxShadow: '0px 6px 10px #CDD2D9'}}>
                  <div style={{display:'flex', justifyContent:'space-between', marginBottom:'15px', marginTop:'5px'}}>
                      <h5 style={{ font: 'normal normal normal 32px/40px Calibri' }}>Input Module Uploads</h5>
                      {showmappinglne ? <p style={{ color: 'white', backgroundColor: 'rgb(6, 84, 173)', fontWeight: 'bold' }}>Do the Mappings , needed for first time uploading</p> : ""}
                      <Box sx={{marginRight:'12px', display:'flex', alignItems:'center', width:'260px', justifyContent: 'space-between'}}>
                       
                        <Button onClick={onClickPreview} disabled={!configType || !company || !associate_company } variant='contained' > Preview </Button>
                        {
                    hasUserAccess(USER_PRIVILEGES.ADD_INPUT_MODULE_UPLOAD) &&
                        <Button onClick={onClickUpload} variant='contained' style={{marginRight:'10px', backgroundColor:'#E9704B', display:'flex', alignItems:'center'}}> <FaUpload /> &nbsp; Upload</Button>
                  }

                        {/* <Button onClick={onClickUpload} variant='contained' style={{marginRight:'10px', backgroundColor:'#E9704B', display:'flex', alignItems:'center'}}> <FaUpload /> &nbsp; Upload</Button> */}
                      </Box>
                  </div>
                  <div style={{display:'flex', marginBottom:'10px'}}>

                  <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Configuration Type</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'190px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={configType}
                          onChange={handleChangeConfigType}
                          MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 200,
                              width: 230,
                              marginTop: "3px"
                            }
                          }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Configuration Type
                          </MenuItem>
                          {configurationTypes && configurationTypes.map((each:any) => 
                            <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each}>{each}</MenuItem>
                          )}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Company</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'190px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          value={company}
                          displayEmpty
                          disabled={!configType}
                      onChange={handleChangeCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Company
                          </MenuItem>
                          {companies && companies.map((each:any) => {
                              return <MenuItem sx={{width:'240px', whiteSpace:'initial'}} value={each.id}>{each.name}</MenuItem>
                          })}
                        </MSelect>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Associate Company</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'190px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <MSelect
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={associate_company}
                          disabled={!company}
                      onChange={handleChangeAssociateCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Associate Company
                          </MenuItem>
                          {associateCompanies && associateCompanies.map((each:any) => {
                            return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                          })}
                        </MSelect>
                      </FormControl>
                    </Box>
                  </div>
              </Box>
            </Box>
            {(configType && company && associate_company) && tableData && tableData.length > 0 && 
              <Box sx={{paddingX: '20px', display: 'flex', flexDirection:'column'}}> 
                <TableContainer sx={{border:'1px solid #e6e6e6', marginTop:'10px', maxHeight:'380px', overflowY:'scroll'}}>
                        <Table stickyHeader  sx={{ minWidth: 650 }} aria-label="sticky table">
                            <TableHead sx={{'.MuiTableCell-root':{ backgroundColor:'#E7EEF7'}}}>
                                <TableRow>
                                    <TableCell sx={{ width: '60px' }}>S.no</TableCell>
                                    <TableCell sx={{ width: '180px' }}> Column Name</TableCell>
                                    <TableCell sx={{ width: '90px' }}> Column Position</TableCell>
                                    <TableCell sx={{ width: '90px' }}> Row Position</TableCell>
                                    <TableCell sx={{ width: '280px' }}> Ezycomp Field</TableCell>
                                    <TableCell sx={{ width: '80px' }}> Mapped</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>

                            {tableData && tableData.map((each: any, index: number) => (
                                <TableRow
                                key={each._id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >   
                                    <TableCell >{index+1}</TableCell>
                                    <TableCell sx={{ width: '180px' }}>{each.excel_column_header_name}</TableCell>
                                    <TableCell >{each.column_position}</TableCell>
                                    <TableCell >{each.row_position}</TableCell>
                                    <TableCell >
                                      <FormControl sx={{ m: 1, width:"100%", maxWidth:'250px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                                        <Select
                                          options={columnsList ? columnsList.map((each:any) => {return {label : each.field_name, value: each.field_name}}) : []}
                                          className="basic-multi-select"
                                          classNamePrefix="select"
                                          value={each.employee_field_name ? {label: each.employee_field_name, value: each.employee_field_name} : ''}
                                          styles={customStyles}
                                          onChange={(e) => handleChangeEzycompField(e, each)}
                                          isDisabled={configMappingList && (configMappingList.find((item: any) => item.id === each.id) || {}).mapped}
                                      />
                                    </FormControl>
                                    </TableCell>
                                    <TableCell >{each.mapped ? "Yes" : "No"}</TableCell>
                                    </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                </TableContainer>
              {enableUpdate && <Button sx={{marginTop:'20px', alignSelf:'flex-end', width:'200px'}} variant='contained' onClick={onClickSave}>Save</Button>}
            </Box>}
            {(!configType || !company || !associate_company || (tableData && tableData.length == 0)) && 
              <Box sx={{height:'60vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography variant='h5'>No Records Found. {showUploadMessage ? "Please Upload the new configuration" : ""}</Typography>
            </Box>}
        </div>
      }
    </div>
  )
}

export default Configurations